import { render, staticRenderFns } from "./gene_table.vue?vue&type=template&id=26fc0f6e&"
import script from "./gene_table.vue?vue&type=script&lang=js&"
export * from "./gene_table.vue?vue&type=script&lang=js&"
import style0 from "./gene_table.vue?vue&type=style&index=0&id=26fc0f6e&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports